import React from 'react';
import BaseTableNew from 'components/atoms/base-table/new';
import { useNoteLog } from 'infrastructure/hooks/logs/use-note-log';

import { notesLogsColumns } from './cols';

interface IPatientThresholdLogProps {
  patientGuid: string;
  dateRange?: [Date, Date];
}

const PatientDeletedNotesLog: React.FC<IPatientThresholdLogProps> = (props) => {
  const { patientGuid, dateRange } = props;

  const { loading, items, meta, setMeta } = useNoteLog({
    patientGuid,
    meta: {
      dateRange,
    },
  });

  const onChangePage = (page: number) => {
    setMeta({
      ...meta,
      page,
    });
  };

  return (
    <BaseTableNew
      rowKey="key"
      dataCy="deleted-notes-log-table"
      columns={notesLogsColumns()}
      items={items}
      loading={loading}
      pagination={{
        current: meta.page,
        pageSize: meta.items,
        total: meta.totalCount,
      }}
      onChangePage={onChangePage}
      bordered
    />
  );
};

export default PatientDeletedNotesLog;
